import React from 'react'
import { useState, useEffect, useContext, useRef, useReducer } from "react";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { db } from '../../config/firebase';
import Picker from "emoji-picker-react";
import { FaUsers } from "react-icons/fa6";
import { FaUserLarge } from "react-icons/fa6";
import { LuUser2 } from "react-icons/lu";
import { IoPersonRemove } from "react-icons/io5";
import { IoPersonRemoveOutline } from "react-icons/io5";
import useOutsideCloser from '../../custom hooks/clickOutsideCloser';
import { TiArrowBackOutline } from "react-icons/ti";

import { BsCopy } from "react-icons/bs";
import { MdGroupAdd } from "react-icons/md";
import { PiNotePencil } from "react-icons/pi";
import { BsTrash3 } from "react-icons/bs";

import {
  getDocs,
  collection,
  query,
  where,
  orderBy,
  limit,
  arrayUnion,
  doc,
  getDoc,
  deleteDoc,
  Timestamp,
  updateDoc,
  onSnapshot
} from "firebase/firestore";

import { CiLock } from "react-icons/ci";
import { CiUnlock } from "react-icons/ci";
import { FcGoogle } from "react-icons/fc";
import ReactGA from "react-ga4";
import { PiIdentificationCardLight } from "react-icons/pi";
import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import { HiOutlineIdentification } from "react-icons/hi2";
import { VscWholeWord } from "react-icons/vsc";
import { RiLockPasswordLine } from "react-icons/ri";
import { FiSearch } from "react-icons/fi";
import { FaUserLock } from "react-icons/fa";

import { CiRead, CiUnread } from "react-icons/ci";

import Spinner from '../../components/Loading/TailSpin';
import Checkbox from '../../components/Input/Checkbox';

import dayjs from 'dayjs';
import GroupsMultiselect from '../../components/Dropdown/GroupsMultiSelect';
import { RxCross2 } from 'react-icons/rx';
import ManageUserCheckBox from '../../components/Input/customCheckbox';
import CopyComponent from './components/Copy';
import ModalAnimation from '../../components/animations/ModalAnimation';
import PopupAnimation from '../../components/animations/PopupAnimation';
import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat);


function ManageGroups({ }) {
  const navigate = useNavigate();
  const location = useLocation();

  // const { } = useContext(Context);

  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [usersExceptInGrp, setUsersExceptInGrp] = useState([]);
  const [fetchedGroups, setFetchedGroups] = useState([]);
  const [groupsWrapper, setgroupsWrapper] = useState(false)

  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isAddGroupOpen, setIsAddGroupOpen] = useState(false);


  // User DETAILS
  const [profile, setProfile] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [UID, setUID] = useState("");
  const [password, setPassword] = useState("");
  const [isAnonymous, setIsAnonymous] = useState(false);

  const [canEditName, setCanEditName] = useState(false);
  const [canEditsetProfile, setCanEditsetProfile] = useState(false);
  const [canEditsetDisplayName, setCanEditsetDisplayName] = useState(false);
  const [canEditsetPassword, setCanEditsetPassword] = useState(false);
  const [canEditsetIsAnonymous, setCanEditsetIsAnonymous] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);

  const [name, setName] = useState("")
  const [desc, setDesc] = useState("");
  const [groupId, setGroupId] = useState("")


  const [usersList, setUsersList] = useState([])
  const [search, setSearch] = useState("");

  const [innerSearch, setInnerSearch] = useState("")


  const modeSelectionTab = [
    {
      name: "Public",
      icon: <CiRead className="w-full h-full" />,
    },
    {
      name: "Anonymous",
      icon: <CiUnread className="w-full h-full" />,
    },
  ]

  const [currModeSelectionTab, setCurrModeSelectionTab] = useState(0);

  useEffect(() => {

    const getUsers = async (id) => {
      setIsLoading(true)
      try {
        const collectionRef = collection(db, 'users')
        let q = query(collectionRef, orderBy("createdAt"), limit(50));
        // if (groupId !== "") {
        //   q = 
        // } else {
        //   q = query(collectionRef, orderBy("createdAt"), limit(50));
        // }
        const data = await getDocs(q);
        const reqData = data.docs.map((item) => {
          return {
            ...item.data(),
            id: item.id,
            isSelected: false,
            createdAt: dayjs(new Date(item.data().createdAt.seconds * 1000 + item.data().createdAt.nanoseconds / 1000000,)).format("lll"),
          }
        })
        setUsers(reqData);

        // console.log("Fetched users Data UE: ", reqData);
      } catch (error) {
        // console.log(error);
      }
      setIsLoading(false)
    }

    const getGroups = async (id) => {
      setIsLoading(true)
      try {
        const collectionRef = collection(db, 'groups')
        let q = query(collectionRef, where("isIndividual", "==", false), orderBy("createdAt"), limit(50));
        // if (groupId !== "") {
        //   q = 
        // } else {
        //   q = query(collectionRef, orderBy("createdAt"), limit(50));
        // }

        const data = await getDocs(q);
        const reqData = data.docs.map((item) => {
          return {
            ...item.data(),
            id: item.id,
            createdAt: dayjs(new Date(item.data().createdAt.seconds * 1000 + item.data().createdAt.nanoseconds / 1000000,)).format("lll"),
          }
        })
        setFetchedGroups(reqData);

        // console.log("Fetched users Data UE: ", reqData);
      } catch (error) {
        console.log(error);
      }
      setIsLoading(false)
    }

    getUsers();
    getGroups();
  }, []);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Manage Groups" })
  }, [])


  const handleUserClick = (item) => {
    setGroupId(item.id)
    setDesc(item.desc)
    setName(item.name)
    setUsersList(item.users)
    setIsEditOpen(true);
  }

  const handleRmUser = async () => {
    try {
      const userDocRef = doc(db, 'users', removeUserConfDetails.uid);
      const userDocSnap = await getDoc(userDocRef);
      let afterAddnUsersToGroups = userDocSnap.data().groups.filter((item) => (item.groupId !== removeUserConfDetails.groupId));

      if (userDocSnap.exists()) {
        await updateDoc(userDocRef, {
          groups: afterAddnUsersToGroups
        });

        const groupDocRef = doc(db, 'groups', removeUserConfDetails.groupId);
        const groupDocSnap = await getDoc(groupDocRef);
        let rmAfterUser = groupDocSnap.data().users.filter((item) => (item.uid !== removeUserConfDetails.uid));

        // console.log(rmAfterUser);

        if (groupDocSnap.exists()) {
          await updateDoc(groupDocRef, {
            users: rmAfterUser
          });
        }

        setFetchedGroups((prev) => prev.map((item) => {
          if (item.id === removeUserConfDetails.groupId) return { ...item, users: rmAfterUser }
          else return item
        }))
      }
    } catch (error) {
      // console.error("Error adding document: ", error);
    }
    setShowRemoveUserConf(false);
  }

  const handleAddToGroups = async () => {
    try {
      let newUsers = usersExceptInGrp.filter((item) => item.selected)
        .map((item) => ({
          "uid": item.id,
          "displayName": item.displayName
        }))

      const userDocRef = doc(db, 'groups', groupId);
      const userDocSnap = await getDoc(userDocRef);
      let afterAddnUsersToGroups = [...userDocSnap.data().users, ...newUsers];

      // console.log(afterAddnUsersToGroups);

      if (userDocSnap.exists()) {
        await updateDoc(userDocRef, {
          users: afterAddnUsersToGroups
        });

        for (const user of newUsers) {
          //Opposite named
          const groupDocRef = doc(db, 'users', user.uid);
          const docSnap = await getDoc(groupDocRef);

          if (docSnap.exists()) {
            console.log("Adding" + user + "to Group");
            await updateDoc(groupDocRef, {
              groups: arrayUnion({
                "groupId": groupId,
                "isPinned": false,
                "isIndividual": false,
                "name": name
              })
            });
          } else {
            // console.log("Error Adding" + user.name + "to Group");
          }
        }

        setFetchedGroups((prev) => prev.map((item) => {
          if (item.id === groupId) return { ...item, users: afterAddnUsersToGroups }
          else return item
        }))
      }
    } catch (error) {
      // console.error("Error adding document: ", error);
    }
    setIsAddGroupOpen(false);
  }

  const handleUserSelection = (uid) => {
    setFetchedGroups((prev) => (prev.map((item) => {
      if (item.id === uid)
        return {
          ...item,
          isSelected: !item.isSelected,
        };
      else return item
    })))
  }

  const handleSelectAllUsers = (setSelectAllUser) => {
    setSelectAllUser((prev) => {

      setFetchedGroups((prevUser) => (prevUser.map((item) => ({
        ...item,
        isSelected: !prev,
      }))))

      return !prev;
    })
  }

  // Select groups to ADD USERs
  const handleGroupSelection = (id) => {
    // console.log(name);
    setUsersExceptInGrp((prev) => prev.map((item) => {
      if (item.id === id) return {
        ...item, selected: !item.selected
      }
      return item
    }
    ))
  }


  const handleUpdateGroup = async () => {
    const docRef = doc(db, 'groups', groupId);

    try {
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        await updateDoc(docRef, {
          desc,
          name,
        });
        // console.log("Document successfully Edited: ",);
        for (const user of usersList) {

          const groupDocRef = doc(db, 'users', user.uid);
          const docSnap = await getDoc(groupDocRef);

          if (docSnap.exists()) {
            // console.log("Adding" + user.name + "to Group");
            const updatedGroupUsers = docSnap.data().groups
              .map((item) => { if (item.groupId === groupId) return { ...item, name: name }; return item })
            console.log(updatedGroupUsers);

            await updateDoc(groupDocRef, {
              groups: updatedGroupUsers
            });
          } else {
            // console.log("Error Adding" + user.name + "to Group");
          }
        }
        setIsEditOpen(false);
      } else {
        // console.log("DNE: ",);
      }

    } catch (error) {
      // console.error("Error adding document: ", error);
    }
  }

  const handleGroupDelete = async () => {
    const docRef = doc(db, 'groups', groupId);

    try {
      await deleteDoc(docRef);

      setFetchedGroups((prev) => (prev.filter((item) => (item.id !== groupId))))
      setShowDeleteConfirmationPopup(false)
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  }

  //-------------------------------------------------| ALL POPUPS |-------------------------------------------------
  const confirmationRef = useRef(null);
  const rmUserRef = useRef(null);

  // const [showDeleteAllConfirmationPop, setShowDeleteConfirmationPopup] = useState(false);
  // useOutsideCloser(confirmationRef, setShowDeleteConfirmationPopup);

  const [showDeleteConfirmationPop, setShowDeleteConfirmationPopup] = useState(false);
  useOutsideCloser(confirmationRef, setShowDeleteConfirmationPopup);

  const [showRemoveUserConf, setShowRemoveUserConf] = useState(false);
  const [removeUserConfDetails, setRmGrpConfDetail] = useState(null);
  useOutsideCloser(rmUserRef, setShowRemoveUserConf);



  if (true)
    return (
      <div className="relative w-full flex flex-col h-full">

        {/* <TiArrowBackOutline className='w-3.5 h-3.5 md:w-5 md:h-5 '/> */}

        <div className="relative font-semibold text-xl text-headPrimary bg-lightPrimary h-[50px] w-full flex items-center justify-center ">

          <div className="absolute left-6 top-0 bottom-0 my-auto h-fit w-[100px] md:w-[150px] ">
            <div className="border border-gray-300 bg-white text-gray-700 z-1 flex h-[20px] md:h-[28px] w-full flex-grow items-left justify-start gap-2 rounded-md px-1.5 py-0.5">
              <div className="flex h-full w-full items-center font-normal ">
                <FiSearch
                  className="h-3 w-3 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                <input
                  onChange={(e) => {
                    setSearch((e.target.value))
                  }}
                  value={search}
                  type="text"
                  placeholder={window.innerWidth < 600 ? "Search" : "Search for Groups"}
                  className="block ml-0 px-2 h-auto w-full bg-white text-xs md:text-sm text-gray-700 outline-none placeholder:!text-gray-400"
                />
              </div>

            </div>
          </div>

          <div className="">Manage Groups</div>
        </div>


        <div className="h-[calc(100%-112px)] w-full py-2 px-2 overflow-y-auto">

          <div className="rounded-lg w-full h-full flex flex-col">
            <div className="w-full flex items-center justify-between bg-gray-50 p-2 rounded-t-lg gap-3">

              <div className="w-[141px] /bg-green-100 flex">

                <ManageUserCheckBox onChange={() => handleSelectAllUsers(setIsSelectAll)} checked={isSelectAll} />
                <div className="text-xs md:text-sm font-medium /uppercase">Group Details</div>
              </div>

              <div className="flex w-[calc(100%-215px)] gap-2 ">
                <div className="w-fit /bg-green-100 flex flex-col">
                  <div className="text-xs md:text-sm font-medium /uppercase">Users present in Group</div>
                </div>
              </div>

              <div className="w-[60px] md:w-[115px] flex items-center justify-center gap-2 md:gap-4" >

                <MdGroupAdd
                  onClick={() => {
                    setIsAddGroupOpen(true);
                    setName("All Selected");
                  }}
                  className='w-3.5 h-3.5 md:w-5 md:h-5 cursor-pointer text-gray-600 hover:text-headPrimary' />
                <PiNotePencil className='w-3.5 h-3.5 md:w-5 md:h-5 cursor-pointer text-gray-600 hover:text-headPrimary invisible' />
                <BsTrash3
                  onClick={(e) => {
                    setName("All Selected");
                    setShowDeleteConfirmationPopup(true);
                  }}
                  className='w-3.5 h-3.5 md:w-5 md:h-5 cursor-pointer text-gray-600 hover:text-headPrimary' />
              </div>
            </div>

            {fetchedGroups.filter((item) => (search === "" || item.name.toLowerCase().includes(search.toLowerCase())))
              .map((item, ind) => (
                <div className={`w-full flex items-center justify-between ${ind % 2 ? "bg-gray-50" : "bg-white"} p-1 px-2 gap-3 `}>
                  <div className="w-[141px] flex items-center justify-between">
                    {/* onClick={() => { localStorage.setItem("uid", item.id) }} */}
                    <div className="flex items-center" >
                      <ManageUserCheckBox onChange={() => handleUserSelection(item.id)} checked={item.isSelected} />
                      <div className="flex flex-col pr-1 md:pr-2 w-[100px] md:w-full truncate">
                        <div className="text-2xs md:text-xs">{item.name} <span className='text-our-600' >({item.desc})</span></div>
                        <div className="text-2xs md:text-xs text-gray-600 truncate">{item.createdAt}</div>
                      </div>
                    </div>

                    <CopyComponent toCopy={item.id} />
                  </div>

                  <div className="flex w-[calc(100%-215px)] overflow-x-auto gap-2 ">
                    {item.users.map((user, ind) => (
                      <div className={`relative flex flex-col px-1 pr-2.5  min-w-[65px] md:min-w-[82px] ${ind % 2 ? "bg-[#f7f2fe]" : "bg-[#f1fff8]"}`}>

                        <RxCross2 onClick={() => {
                          setShowRemoveUserConf(true);
                          setRmGrpConfDetail({ uid: user.uid, name: user.displayName, groupId: item.id, groupName: item.name });
                        }}
                          className={`absolute top-0.5 right-0.5 h-2.5 w-2.5 text-gray-600 hover:text-white ${ind % 2 ? "hover:bg-headSecondary" : "hover:bg-headPrimary"} rounded-md cursor-pointer`} />

                        <div className="text-2xs md:text-xs w-full truncate ">{user.displayName}</div>
                        <div className="text-2xs md:text-xs text-gray-600">{user.uid}</div>
                      </div>
                    ))}
                  </div>

                  <div className="w-[60px] md:w-[115px] flex items-center justify-center gap-2 md:gap-4" >

                    <MdGroupAdd
                      onClick={() => {
                        // remove Users already present in the Group
                        setUsersExceptInGrp(users.filter((user) => (!item.users.map((grpsUser) => grpsUser.uid).includes(user.id))).map((item) => ({ ...item, selected: false })))
                        setIsAddGroupOpen(true);
                        setGroupId(item.id);
                        setName(item.name);
                      }}
                      className='w-3.5 h-3.5 md:w-5 md:h-5 cursor-pointer text-gray-600 hover:text-headPrimary' />
                    <PiNotePencil
                      onClick={(e) => {
                        handleUserClick(item);
                      }}
                      className='w-3.5 h-3.5 md:w-5 md:h-5 cursor-pointer text-gray-600 hover:text-headPrimary' />
                    <BsTrash3
                      onClick={(e) => {
                        e.stopPropagation();
                        setGroupId(item.id);
                        setName(item.name);
                        setShowDeleteConfirmationPopup(true);
                      }}
                      className='w-3.5 h-3.5 md:w-5 md:h-5 cursor-pointer text-gray-600 hover:text-headPrimary' />
                  </div>

                </div>
              ))}

          </div>
        </div>

        <PopupAnimation showDiv={isAddGroupOpen} >
          <div className="relative flex w-[90vw] h-[75vh] md:w-[382px] p-4 pt-4 md:p-5 flex-col justify-start rounded-xl bg-white shadow-lg outline-none dark:bg-navy-800 focus:outline-none">

            <button
              onClick={() => {
                setIsAddGroupOpen(false)
              }}
              type="button"
              className="bg-transparent absolute absolute top-0 right-0 h-fit w-fit p-2 items-center justify-center rounded-xl text-xs md:text-sm text-gray-400 ms-auto hover:bg-gray-200 hover:text-neuGray dark:hover:bg-gray-600 dark:hover:text-white"
              data-modal-hide="static-modal"
            >
              <svg
                className="h-3 w-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>

            <div className="text-2xl font-semibold text-center text-headPrimary"> Add Users to {name}</div>
            <div className='w-full h-[calc(100%-123px)] p-3 mt-6 flex flex-col bg-lightPrimary rounded-lg' >

              <div className=" h-fit w-[150px] ">
                <div className="border border-gray-300 bg-white text-gray-700 z-1 flex h-[30px] md:h-[28px] w-full flex-grow items-left justify-start gap-2 rounded-md px-1.5 py-0.5">
                  <div className="flex h-full w-full items-center font-normal ">
                    <FiSearch
                      className="h-3 w-3 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                    <input
                      onChange={(e) => {
                        setInnerSearch((e.target.value))
                      }}
                      value={innerSearch}
                      type="text"
                      placeholder="Search for Groups"
                      className="block ml-0 px-2 h-auto w-full bg-white text-xs md:text-sm text-gray-700 outline-none placeholder:!text-gray-400"
                    />
                  </div>

                </div>
              </div>

              <div className="w-full h-[calc(100%-42px)] overflow-y-auto mt-3 py-1 flex flex-col">

                {usersExceptInGrp
                  .filter((item) => (item.name.toLowerCase().includes(innerSearch.toLowerCase())))
                  .map((item, ind) => (
                    <button
                      // onClick={() => (handleGroupSelection(item.name))}
                      key={item.id + "BTN"} className={`flex w-full items-center ${item.selected ? "font-semibold" : ""} hover:font-bold ${ind % 2 ? "bg-gray-50" : "bg-white"} py-1 px-2`}>

                      <Checkbox
                        checked={item.selected}
                        onChange={() => (handleGroupSelection(item.id))} />

                      <label className="ms-2 flex flex-col text-left font-normal cursor-pointer capitalize text-base hover:text-gray-800 dark:text-gray-300">
                        <div className="">{item.name}</div>
                        <div className="text-gray-600 text-2xs md:text-xs">{item.id}</div>
                      </label>
                    </button>

                  ))}
              </div>
            </div>

            <div className="w-full flex items-center justify-center">

              <button
                onClick={handleAddToGroups}
                className=" mt-5 flex items-center justify-center py-2 w-[141px] bg-white rounded-md border text-xl text-headPrimary hover:text-white hover:bg-headPrimary shadow-md hover:shadow-lg hover:font-bold">
                Save Details
              </button>


            </div>
          </div>
        </PopupAnimation>


        <PopupAnimation showDiv={isEditOpen} >
          <div className="relative flex w-[90vw] h-[550px] md:w-[530px] p-6 pt-4 sm:pb-2 sm:p-5 flex-col justify-start rounded-xl bg-white shadow-lg outline-none dark:bg-navy-800 focus:outline-none">

            <button
              onClick={() => {
                setIsEditOpen(false)
              }}
              type="button"
              className="bg-transparent absolute absolute top-0 right-0 h-fit w-fit p-2 items-center justify-center rounded-xl text-xs md:text-sm text-gray-400 ms-auto hover:bg-gray-200 hover:text-neuGray dark:hover:bg-gray-600 dark:hover:text-white"
              data-modal-hide="static-modal"
            >
              <svg
                className="h-3 w-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>

            <div className="text-2xl font-semibold text-center text-headPrimary"> Edit {name} Info </div>

            <div className='w-full h-[calc(100%-30px)] py-5 px-1 mt-1 flex flex-col justify-between' >

              <div className="w-full h-fit md:w-[100%] p-6  bg-lightPrimary flex flex-col items-center rounded-lg ">
                <div className="text-xl font-semibold text-headPrimary">Group Details</div>

                <div className="w-full grid grid-cols-1 gap-4 mt-6">

                  <div className="flex justify-start w-full ">
                    <div className="border border-gray-300 bg-white text-gray-700 dark:bg-navy-900 dark:text-white z-1 flex h-[40px] md:h-[42px] w-full flex-grow items-left justify-start gap-2 rounded-md px-2.5 py-2.5 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2 w-full">
                      <div className="flex h-full w-full items-center font-normal ">
                        <VscWholeWord
                          className="h-4 w-4 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                        <input
                          onChange={(e) => {
                            setName((e.target.value))
                          }}
                          value={name}
                          type="text"
                          placeholder="Full Name"
                          className="block ml-0 px-2 h-auto w-full rounded-full bg-white text-lg text-gray-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                        />
                      </div>
                    </div>

                  </div>

                  <div className="flex justify-start w-full">
                    <div className="border border-gray-300 bg-white text-gray-700 dark:bg-navy-900 dark:text-white z-1 flex h-[40px] md:h-[42px] w-full flex-grow items-left justify-start gap-2 rounded-md px-2.5 py-2.5 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2 w-full">
                      <div className="flex h-full w-full items-center font-normal ">
                        <MdOutlineDriveFileRenameOutline
                          className="h-4 w-4 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                        <input
                          onChange={(e) => {
                            setDesc((e.target.value))
                          }}
                          value={desc}
                          type="text"
                          placeholder="Description"
                          className="block ml-0 px-2 h-auto w-full rounded-full bg-white text-lg text-gray-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                        />
                      </div>

                    </div>
                  </div>


                </div>

              </div>

              <div className="w-full flex items-center justify-center">

                <button
                  onClick={handleUpdateGroup}
                  className=" mt-5 flex items-center justify-center py-2 w-[201px] bg-white rounded-md border text-xl text-headPrimary hover:text-white hover:bg-headPrimary shadow-md hover:shadow-lg hover:font-bold">
                  Save Details
                </button>


              </div>
            </div>
          </div>
        </PopupAnimation>


        <ModalAnimation showDiv={showRemoveUserConf} >
          <div ref={rmUserRef} className="relative flex w-[290px] h-fit flex-col items-center p-5 tracking-wide rounded-xl bg-white outline-none dark:bg-navy-800 focus:outline-none">


            <div className="rounded-full bg-red-600 w-12 h-12 p-2.5">
              <IoPersonRemove className='h-full w-full text-white' />
            </div>

            <div className="text-xl font-bold text-center mt-4">
              Remove Confirmation
            </div>

            <div className="text-base text-center text-gray-700 mt-1">
              Are you sure you want to Remove <span className="text-headPrimary">{removeUserConfDetails?.name}</span> from <span className="text-headSecondary">{removeUserConfDetails?.groupName}</span> Group ?
            </div>

            <button
              onClick={() => { handleRmUser() }}
              className="text-base font-bold bg-lightPrimary hover:text-white hover:bg-headPrimary px-5 py-2 rounded-md cursor-pointer mt-6">
              REMOVE
            </button>
          </div>
        </ModalAnimation>

        <ModalAnimation showDiv={showDeleteConfirmationPop} >
          <div ref={confirmationRef} className="relative flex w-[290px] h-fit flex-col items-center p-5 tracking-wide rounded-xl bg-white outline-none dark:bg-navy-800 focus:outline-none">


            <div className="rounded-full bg-red-600 w-12 h-12 p-2.5">
              <BsTrash3 className='h-full w-full text-white' />
            </div>

            <div className="text-xl font-bold text-center mt-4">
              Delete Confirmation
            </div>

            <div className="text-base text-center text-gray-700 mt-1">
              Are you sure you want to Permanently Delete Group <span className="text-headPrimary">{name}</span> ?
            </div>

            <button
              onClick={() => { handleGroupDelete() }}
              className="text-base font-bold bg-lightPrimary hover:text-white hover:bg-headPrimary px-5 py-2 rounded-md cursor-pointer mt-6">
              DELETE
            </button>
          </div>
        </ModalAnimation>

      </div>

    )
  else
    return (
      <div className="w-full flex flex-col h-full"></div>
    )
}

export default ManageGroups